import type { GamePreset, PresetMetadata } from './types'

const metadata = [
  {
    id: 'mxdc',
    version: 8,
    gameVersion: '079',
    nameKey: 'presets.mxdc.name',
    descriptionKey: 'presets.mxdc.description',
    capabilities: {
      level: 'ocr',
      exp: 'fused',
      hp: 'fused',
      mp: 'fused',
      mesos: 'ocr',
      mapName: 'ocr',
    },
  },
] as const satisfies readonly PresetMetadata[]

const loaders: Readonly<Record<string, () => Promise<{ default: GamePreset }>>> = {
  mxdc: () => import('./mxdc'),
}

export class PresetRegistry {
  static list(): readonly PresetMetadata[] {
    return metadata
  }

  static async load(id: string): Promise<GamePreset> {
    const load = loaders[id]
    if (!load) throw new Error(`Unknown preset: ${id}`)
    return (await load()).default
  }
}
